import gql from 'graphql-tag'

export default gql`
    mutation sendTestCampaignEmail($CampaignID: String!) {
        sendTestCampaignEmail(CampaignID: $CampaignID)
    }
`